/**
 * Homepage “Only in Australia” hero carousel — search/API campaign tag (must match backend/CMS).
 */
export const ONLY_IN_AUSTRALIA_HERO_CAMPAIGN_TAG = 'Only In Australia Hero' as const
export const ONLY_IN_AUSTRALIA_CAMPAIGN_PATH = '/campaign/only-in-australia' as const
